<template>
    <v-container fluid grid-list-md>
        <campaigns></campaigns>
    </v-container>
</template>
<script>
import Campaigns from '@/components/Campaigns/List.vue';
export default {
    components: {
        Campaigns
    }
};
</script>
